module.exports = __webpack_public_path__ + "img/zixuncode-lss.f4a23bdb.png";